// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1407":"cfae8c1c","1996":"034c8552","2969":"95e185ae","5046":"ca047796","6673":"a85bcda8","7041":"70dd94cd","7466":"3c9b3667"}[chunkId] + ".chunk.css";
};